export default function(state={}, action){
  switch(action.type) {
      case 'LOGIN':
        return {...state, login:action.paylod}
      case 'AUTH':
        return {...state, login:action.paylod}
      default:
          return state;
  }
}